import styled, { css } from 'styled-components';

export const Wrapper = styled.section`
  ${({ theme }) => css`
    background-color: ${theme.colors.globalWhite100};
    width: 100%;
  `}
`;

export const Container = styled.div`
  max-width: 1320px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;

  @media (max-width: 992px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const Content = styled.div`
  margin: auto 0;
  padding: 26px 0;
  max-width: 700px;
  width: 100%;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: 5.6rem;
    line-height: 6.2rem;
    color: ${theme.colors.neutralSilver90};
    line-height: 1;
    max-width: 574px;
    margin-bottom: 32px;
    font-weight: 700;

    @media (max-width: 992px) {
      font-size: 3.2rem;
      line-height: 1.23;
      font-weight: 700;
      max-width: 100%;
    }
  `}
`;

export const CustomContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;

  > div {
    max-width: 140px;
    // width: 100%;
  }

  p {
    font-size: 1.2rem;
    line-height: 1.6;
  }

  @media (max-width: 992px) {
    > div {
      max-width: calc(50% - 12px);
    }
  }

  @media (max-width: 375px) {
    > div {
      max-width: calc(100%);
    }
  }
`;

export const Image = styled.img`
  max-width: 552px;
  width: 100%;
  display: none;

  @media (min-width: 1024px) {
    display: block;
  }

  @media (max-width: 768px) {
    max-width: 280px;
  }
`;
